module.exports = __webpack_public_path__ + "img/unit1-federated.81f0d4bd.svg";